export default __webpack_public_path__ + "static/media/earphones10.7f23307e.jfif";